import React from 'react';
import moment from 'moment';
import { BsCheck2Circle, BsCircleFill } from "react-icons/bs";
import IconUI from '../components/iu/icon_ui'; 

export const SemaforoMap = {
  ATENDIDA: (
    <IconUI size="20px" color="green">
      <BsCheck2Circle />
    </IconUI>
  ),
  VERDE: (
    <IconUI size="20px" color="green">
      <BsCircleFill />
    </IconUI>
  ),
  AMARILLO: (
    <IconUI size="20px" color="yellow">
      <BsCircleFill />
    </IconUI>
  ),
  ROJO: (
    <IconUI size="20px" color="red">
      <BsCircleFill />
    </IconUI>
  ),
};

export const renderCell = (data, field, height = "30px") => (dataIndex) => {
  const value = data[dataIndex]?.[field];
  const content = SemaforoMap[value] ?? value;

  return (
    <div className="d-flex align-items-center" style={{ height }}>
      {content}
    </div>
  );
};

export const renderDate = (data) => (index) => (
  <div className="d-flex align-items-center" style={{ height: "60px" }}>
    {data[index]?.fecha_creacion 
      ? moment(data[index].fecha_creacion, "DD-MM-YYYY").format("DD-MM-YYYY") 
      : "-"}
  </div>
);
